import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StarRating from 'components/Shared/StarRating';
import { screen } from 'components/styles/variables';

export default function Rating({ value }) {
  const { t } = useTranslation();

  return (
    <div className="dealer-rating-container">
      <StarRating value={value} />
      <h3 className="dealer-page-overall-rating">
        {t('dealerPages.overallRating')}
      </h3>
      <style jsx>{`
        .dealer-rating-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 16px;
          flex: 0 0 105px;
        }

        .dealer-page-overall-rating {
          text-transform: uppercase;
          font-size: 13px;
          margin: 3px 0 0 0;
          text-align: center;
        }

        @media screen and (min-width: ${screen.smMin}) {
          .dealer-rating-container {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}

Rating.propTypes = {
  value: PropTypes.number.isRequired,
};
